module.exports = __webpack_public_path__ + "img/ReserveIcon.7fc8fbea.svg";